import type { NavigateFunction, NavigateOptions, To } from 'react-router-dom';

let globalNavigateRef: ((to: To, options?: NavigateOptions) => void) | null =
    null;

export function setGlobalNavigate(navigate: NavigateFunction | null) {
    globalNavigateRef = navigate
        ? (to, options) => navigate(to, options)
        : null;
}

export function globalNavigateTo(to: string, options?: NavigateOptions) {
    if (!globalNavigateRef) {
        window.location.href = to;
        return;
    }
    globalNavigateRef(to, options);
}
